/* global axios */
import ApiClient from '../ApiClient';

class ScheduledMessagesApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get({ conversationId }) {
    return axios.get(`${this.url}/${conversationId}/scheduled_messages`);
  }

  create({ conversationId, content, scheduledAt, files = [] }) {
    const payload = new FormData();
    payload.append('content', content);
    payload.append('scheduled_at', scheduledAt);
    files.forEach(file => payload.append('attachments[]', file));

    return axios.post(
      `${this.url}/${conversationId}/scheduled_messages`,
      payload
    );
  }

  delete(conversationId, scheduledMessageId) {
    return axios.delete(
      `${this.url}/${conversationId}/scheduled_messages/${scheduledMessageId}`
    );
  }
}

export default new ScheduledMessagesApi();
